import { v4 as uuidv4, v4 } from 'uuid';
import deadlines from '../Deadlines';
import { deviceSubstitutionStatus, keyId } from '../../lib/utils';

/**
 * Duplicates a device and its associated fields and non conformities
 *
 * #duplicateDevice
 * @param {Object} data Device data
 * @param {Function} duplicateNonConformities Function to duplicate non conformities
 * @returns {undefined}
 */
export const duplicateDeviceFn = (data = {}, duplicateNonConformities=()=>{}) => {   
    const {device, client, currentTemplate, register, allPositions, setDateFields, setCurrentLocation, setSubstituteDevice, setSubstituteDeviceFields, setSubstituteReason, setDeviceFields, setDeviceStatus} = data
    // SETS LOCATION, IF AUTO POSITION IS TRUE IN THE REGISTER TEMPLATE, FINDS NEXT AVAILABLE POSITION, IF NOT LEAVES IT BLANK
    const expiry = deadlines(device, currentTemplate) 
    if(currentTemplate?.autoPosition){
        /**
         * Finds the next available position in the register template
         * If the current position is the last available position, returns undefined
         * @returns {Object} A document containing the next available position
         */
        const nextPosition = () => {
            const findCurrentPositionDoc = !Array.isArray(device?.locations) ? undefined : device?.locations?.find?.(x=>x?.templateField._ref == "5710d994-8bc9-4981-a5af-94a535d27bbd")
            const oldPosition = findCurrentPositionDoc?.values?.length > 0 && findCurrentPositionDoc?.values?.[0]?.value
            const newPosition = () => {
                for(const position of allPositions) {
                    
                    const nextPosition = position + 1
                    const isNextPositionPresent = allPositions?.some?.((x)=>x == nextPosition)
                    if (nextPosition  > +oldPosition && !isNextPositionPresent) {
                        //console.log("RETURNED POSITION:", nextPosition)
                        return nextPosition
                    } else {
                        //console.log("CURRENT POSITION: ", position, "NEXT POSITION: ", nextPosition, "IS LESS THAN ", +oldPosition, "OR PRESENT IN ", allPositions)
                    }
                }
            }
            const positionDoc = {
                ...findCurrentPositionDoc,
                values:[{
                    value: newPosition()?.toString(),
                    label: newPosition()?.toString(),
                    _key: keyId(),
                    _type: "deviceProperty"
                }]
            }
            return positionDoc
        }
        const locations = !device?.locations ? [] : device?.locations
        //console.log("DUPLICATING DEVICE", positionsString())
        setCurrentLocation ([...!Array.isArray(locations) ? [] : locations?.filter?.(x=>x?.templateField?._ref !== "5710d994-8bc9-4981-a5af-94a535d27bbd"), nextPosition()])
    } else {
        const locations = !device?.locations ? [] : device?.locations
        setCurrentLocation (!Array.isArray(locations) ? [] : locations?.filter?.(x=>x?.templateField?._ref !== "5710d994-8bc9-4981-a5af-94a535d27bbd"))
    }
    setSubstituteDevice(undefined)
    setSubstituteDeviceFields(undefined)
    setSubstituteReason(undefined)
    //  IT DUPLICATES THE FIELDS THAT ARE SET TO BE DUPLICATED IN THE REGISTER TEMPLATE
    const deviceFields =  Array.isArray(device?.fields) ?  device?.fields : []
    const fieldsToDuplicate = deviceFields?.filter?.((x)=>Array.isArray(currentTemplate?.duplicateFields) && currentTemplate?.duplicateFields?.some?.((y)=>y?._ref == x?.templateField?._ref))
    setDeviceFields(fieldsToDuplicate)

  


    /**
     * Function to find non conformities associated with fields to duplicate
     * Finds template fields with generated non conformities
     * Finds the non conformities associated with those fields
     * Checks if the non conformity is not archived or completed
     * Returns an array of new device non conformity documents
     * #duplicateDevice
     */

    const nonConformitiesFromFieldsToDuplicate = () => {
        const templateFieldsWithGeneratedNonConformities = !Array.isArray(currentTemplate?.fields) ? [] : currentTemplate?.fields?.filter?.((x)=>x?.fieldGeneratedNonConformity)
        const generatedNonConformities = templateFieldsWithGeneratedNonConformities?.map((x)=>x?.nonConformities)?.flat()
        //const nonConformities = !Array.isArray(fieldsToDuplicate) ? [] : fieldsToDuplicate?.map?.((x)=>x?.nonConformity)
        
        const duplicateNonConformities = device?.nonConformities?.map((x)=>{
        //console.log("jsojsdoidfdsjf", {x, generatedNonConformities})
        if(generatedNonConformities?.some?.((y)=>y?._id == x?.nonConformity?._ref && x?.status !== "ARCHIVIATO" && x?.status !== "COMPLETATO")) return x
        return 
        })
        ?.filter((x)=>x)
        ?.map((item)=>{
        const newDeviceNonConformityDoc = {...item, _id: uuidv4(), _key: keyId(), comments: [], createdOn: Date.now()}
        return newDeviceNonConformityDoc
        })

        return (duplicateNonConformities)
    }
    //console.log("jclasxjamlxkasjmclkasmcksl", nonConformitiesFromFieldsToDuplicate())
    duplicateNonConformities(nonConformitiesFromFieldsToDuplicate())

    const dateFields =  Array.isArray(device?.dates) ?  device?.dates : []
    const dateFieldsToDuplicate = dateFields?.filter?.((x)=>Array.isArray(currentTemplate?.duplicateFields) && currentTemplate?.duplicateFields?.some?.((y)=>y?._ref == x?.templateField?._ref))
    setDateFields(dateFieldsToDuplicate)
    setDeviceStatus(deviceSubstitutionStatus({device, deviceStatus:"ATTIVO", deadlines: expiry, client}))
  
}